import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { CRMTypesResponse, RxJSStateDefinable } from '../Types/Types'
import { CRMConfigurationTemplateType } from '../../../ReactRouting/Components/Organisms/CRMConfiguration/Modal/Constants/Constants'

const crmTypesSubject: BehaviorSubject<Definable<Record<CRMConfigurationTemplateType, CRMTypesResponse[]>>> =
    new BehaviorSubject<Definable<Record<CRMConfigurationTemplateType, CRMTypesResponse[]>>>(undefined)

RxJS.crmTypes = RxJS.crmTypes ?? {
    subject: crmTypesSubject,
    observable: crmTypesSubject.asObservable(),
    announce: (types?: Record<CRMConfigurationTemplateType, CRMTypesResponse[]>): void => {
        crmTypesSubject.next(types ?? ({} as Record<CRMConfigurationTemplateType, CRMTypesResponse[]>))
    }
}

export const crmTypes$: RxJSStateDefinable<Record<CRMConfigurationTemplateType, CRMTypesResponse[]>> = RxJS.crmTypes
